import { Environment } from './environment.interface';
import { e2eNewsFixture } from './e2e-news-fixture';

export const environment: Environment = {
    name: 'test',
    production: false,
    crmEnabled: true,
    trackingEnabled: true,
    e2eTestHooksEnabled: true,
    e2eNewsFixture,
    apiBaseUrl: '', // the same protocol, domain and port on test (dev environment) will result in https://dev.timebuzzer.com
};
